import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import {
  ListGroup, Row, Col, Container,
} from 'react-bootstrap';
import { paramPropType } from '../hooks';
import ParamsItem from './item';
import ParamsProps from './props';

function ParamsPage({
  params, activeParam, setActiveParam, onParamChange, allowedCtypes,
  onMoveUp, onMoveDown,
}) {
  const displayParams = useMemo(
    () => params
      .map((param, key) => ({ ...param, key }))
      .sort((a, b) => (a.sort || 0) - (b.sort || 0)),
    [params],
  );
  const activeProperties = useMemo(
    () => params.reduce((R, p) => (p.name === activeParam ? p : R), {}),
    [activeParam, params],
  );
  return (
    <Container fluid>
      <Row>
        <Col lg={3} md={6} sm={12} className="p-3">
          <ListGroup>
            {displayParams.map((param, idx) => (
              <ParamsItem
                key={param.key}
                onClick={() => setActiveParam(param.name)}
                value={param}
                active={param.name === activeParam}
                onMoveUp={() => onMoveUp(param.name)}
                onMoveDown={() => onMoveDown(param.name)}
                canUp={idx > 0}
                canDown={idx < (displayParams.length - 1)}
              />
            ))}
          </ListGroup>
        </Col>
        <Col className="containerCol">
          <ParamsProps
            onChange={(v) => onParamChange(activeParam, v)}
            allowedCtypes={allowedCtypes}
            value={activeProperties}
            readOnly={!('name' in activeProperties)}
          />
        </Col>
      </Row>
    </Container>
  );
}

ParamsPage.propTypes = {
  params: PropTypes.arrayOf(paramPropType).isRequired,
  activeParam: PropTypes.string,
  setActiveParam: PropTypes.func.isRequired,
  onParamChange: PropTypes.func.isRequired,
  allowedCtypes: PropTypes.arrayOf(PropTypes.string),
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired,
};

ParamsPage.defaultProps = {
  activeParam: null,
  allowedCtypes: [],
};

export default memo(ParamsPage);
